export default __webpack_public_path__ + "static/media/24.729b0560.webp";